module.exports = __webpack_public_path__ + "img/sagging-skin.5b6e1afa.svg";